import { Route, UrlMatcher, UrlSegment, UrlSegmentGroup } from '@angular/router';

/** 404頁面的UrlMatcher */
export function notfoundMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByPath('404')(segments, group, route);
}
/** sitemap頁面的UrlMatcher */
export function sitemapMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByPath('sitemap')(segments, group, route);
}
/** search頁面的UrlMatcher */
export function searchMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByPath('search')(segments, group, route);
}
/** errorReport頁面的UrlMatcher */
export function errorReportMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByPath('errorReport')(segments, group, route);
}
/** 空字串頁面的UrlMatcher */
export function emptyMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByPath('')(segments, group, route);
}
/** 需要取得lang參數的頁面的UrlMatcher */
export function langMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByParamablePath('lang')(segments, group, route);
}
/** 需要取得cmsType參數的頁面的UrlMatcher */

export function cmsTypeMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByParamablePath('cmsType')(segments, group, route);
}
/** 需要取得id參數的頁面的UrlMatcher */
export function idMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return customUrlMatcherByParamablePath('id')(segments, group, route);
}

/**
 * 產生一個UrlMatcher，可以匹配到指定的固定路徑（無論有沒有包含.html後綴）
 * @param path 欲匹配的固定基礎路徑
 */
export function customUrlMatcherByPath(path: string): UrlMatcher {
  return (segments: UrlSegment[], group: UrlSegmentGroup, route: Route) => {
    // 當切割後的網址區段(用斜線進行切割)只有一個時，代表目前瀏覽的頁面是目前的頁面
    // 同時segment[0]的path必須符合指定的path（無論有沒有包含.html後綴）
    if (segments.length === 1 && segments[0].path.match(new RegExp(`^${path}(\\.html)?`, 'g'))) {
      // console.log(`${path} is matched`, segments, group, route);
      const segment = segments[0];
      const segmentPath = segment.path;
      const isEndWithHtml = segmentPath.endsWith('.html');
      // 改動匹配的網址區段，補上.html結尾（由於是目前頁面，所以需要）
      const modifiedSegment = new UrlSegment(isEndWithHtml ? segmentPath : segmentPath + '.html', segment.parameters);
      return {
        consumed: [modifiedSegment],
      };
    }
    return null;
  };
}

/**
 * 產生一個UrlMatcher，可以匹配到使用變數參數的路徑
 *
 * 比如選單/詳細頁等等，並將該參數抽取出來供ParamMap使用
 * @param paramKey 欲匹配的參數鍵名稱
 */
export function customUrlMatcherByParamablePath(paramKey: string): UrlMatcher {
  return (segments: UrlSegment[], group: UrlSegmentGroup, route: Route) => {
    // 當切割後的網址區段(用斜線進行切割)大於一個時，代表目前瀏覽的頁面是子頁面而非目前的頁面
    if (segments.length > 1) {
      // console.log(`${paramKey} is matched`, segments, group, route);
      // 對應的參數網址區段都會是陣列當中的第一個元素
      const segment = segments[0];
      // 取得網址區段的path（也就是url）
      const segmentPath = segment.path;
      // 判斷網址區段的path是否是.html結尾
      const isEndWithHtml = segmentPath.endsWith('.html');
      // 由於paramMap需要對應的參數，同時參數部份並不需要.html，因此進行取代
      const sliceParam = isEndWithHtml ? segmentPath.replace('.html', '') : segmentPath;
      // 改動匹配的網址區段，將.html結尾去掉（由於是子頁面，所以不需要）
      const modifiedSegment = new UrlSegment(isEndWithHtml ? segmentPath.replace('.html', '') : segmentPath, segment.parameters);
      // 回傳匹配結果
      // consumed的部份會在後續產生RouteSnapshot的時候使用到，也代表會影響網址的顯示
      // posParams的部份代表paramKey所對應的value。
      return {
        consumed: [modifiedSegment],
        posParams: {
          [paramKey]: new UrlSegment(sliceParam, {}),
        }
      };
    }
    // 當切割後的網址區段(用斜線進行切割)只有一個時，代表目前瀏覽的頁面是目前的頁面
    if (segments.length === 1) {
      // console.log(`${paramKey} is matched`, segments, group, route);
      const segment = segments[0];
      const segmentPath = segment.path;
      const isEndWithHtml = segmentPath.endsWith('.html');
      // 由於paramMap需要對應的參數，同時參數部份並不需要.html，因此進行取代
      const sliceParam = isEndWithHtml ? segmentPath.replace('.html', '') : segmentPath;
      // 改動匹配的網址區段，補上.html結尾（由於是目前頁面，所以需要）
      const modifiedSegment = new UrlSegment(isEndWithHtml ? segmentPath : segmentPath + '.html', segment.parameters);
      return {
        consumed: [modifiedSegment],
        posParams: {
          [paramKey]: new UrlSegment(sliceParam, {}),
        }
      };
    }
    // 如果空陣列代表沒有匹配到，回傳null
    return null;
  };







}


